import { createActions, createReducer } from 'reduxsauce'
import ArquivosAnexosService from '../../servicos/ArquivosAnexosService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaAnexosRecursoConcedidoInicio: [],
    buscaAnexosRecursoConcedidoSucesso: ['anexosRecursoConcedido'],
    buscaAnexosRecursoConcedidoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaAnexosRecursoConcedido = filtro => {
    return dispatch => {
        dispatch(Creators.buscaAnexosRecursoConcedidoInicio())
        let serv = new ArquivosAnexosService()
        return serv
            .consultarAnexos(filtro)
            .then(response => dispatch(Creators.buscaAnexosRecursoConcedidoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaAnexosRecursoConcedidoErro(error)))
    }
}

const buscaAnexosRecursoConcedidoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaAnexosRecursoConcedidoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaAnexosRecursoConcedidoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.anexosRecursoConcedido, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_ANEXOS_RECURSO_CONCEDIDO_INICIO]: buscaAnexosRecursoConcedidoInicio,
    [Types.BUSCA_ANEXOS_RECURSO_CONCEDIDO_ERRO]: buscaAnexosRecursoConcedidoErro,
    [Types.BUSCA_ANEXOS_RECURSO_CONCEDIDO_SUCESSO]: buscaAnexosRecursoConcedidoSucesso,
})
